import { createSlice } from "@reduxjs/toolkit";
import dayjs from "dayjs";

const returnHeaderB2C = createSlice({
  name: "returnHeaderB2C",
  initialState: {
    customer: null,
    contact: 0,
    retNo: 0,
    BatchNo: 0,
    invo: null,
    date: dayjs(),
    dealer: null,
    outlet: { Typ: "shamil" },
    edit: false,
    retBill: 0,
    invtyp: "",
    priceLevel: { id: 1, label: "A" },
    address: "",
    vatNo: "",
    taxEnabled: false,
    note: "",
    billTime: new Date().toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    }),
  },
  reducers: {
    updateSelected: (state, action) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    resetState: () => {
      // Reset the state to its initial/default values
      return {
        customer: null,
        contact: 0,
        // retNo: 0,
        // BatchNo: 0,
        invo: 0,
        date: dayjs(),
        invtyp: { Typ: "B2B" },
        // dealer: null,
        // outlet: null
      };
    },
  },
});

export const { updateSelected, resetState } = returnHeaderB2C.actions;
export default returnHeaderB2C.reducer;
